/** Dutch (nl-BE) translations — single source of truth, no hardcoded strings in components. */
const nl = {
  common: {
    save: "Opslaan",
    cancel: "Annuleren",
    close: "Sluiten",
    search: "Zoeken",
    edit: "Bewerken",
    loading: "Laden…",
    error_generic: "Er ging iets mis. Probeer opnieuw.",
    no_results: "Geen resultaten",
    all: "Alle",
    logout: "Afmelden",
    copy: "Kopiëren",
    copied: "Gekopieerd",
    new: "Nieuw",
  },
  auth: {
    welcome_back: "Welkom terug",
    subtitle: "Meld u aan bij FlowNavigator",
    email: "E-mailadres",
    password: "Wachtwoord",
    login: "Aanmelden",
    logging_in: "Bezig met aanmelden…",
    forgot: "Wachtwoord vergeten?",
    invalid: "Ongeldige inloggegevens",
    tagline: "Kalm, professioneel — voor Vlaamse makelaars.",
  },
  nav: {
    pipeline: "Pipeline",
    dashboard: "Dashboard",
    leads: "Leads",
    contacts: "Contacten",
    goals: "Vergelijkingspunten",
    tasks: "Taken",
    reports: "Rapporten",
    settings: "Instellingen",
    users: "Gebruikers",
    statuses: "Statussen",
    particulieren: "Particulieren",
    parkeren: "Parkeren",
  },
  goals: {
    title: "Doelstellingen",
    sub: "Persoonlijke targets en team-prestaties — binnenkort beschikbaar.",
    placeholder_title: "Deze pagina komt eraan",
    placeholder_body: "Hier definieer je straks je eigen targets — calls per dag, brieven per week, mandaten per maand — met overzicht van wie binnen het team op koers ligt.",
    coming_soon: "In ontwikkeling",
  },
  dashboard: {
    greeting_morning: "Goedemorgen",
    greeting_afternoon: "Goedemiddag",
    greeting_evening: "Goedenavond",
    last_active: "Laatst actief",
    start_session: "Start belsessie",
    open_tasks: "Open taken",
    shortlist: "Shortlist",
    calls_week: "Calls deze week",
    potential: "Potentieel",
    active_mandates: "{count} actieve mandaten",
    pick_postcode: "Met welke postcode wilt u vandaag werken?",
    pick_postcode_sub: "Klik om door te gaan naar de prospectie voor die regio.",
    active: "actief",
    signed_short: "getekend",
    recent_activity: "Recente activiteit",
    recent_sub: "Wat er de laatste 24u gebeurd is.",
    empty_activity: "Nog geen activiteit geregistreerd.",
  },
  leads: {
    overview_title: "Lead-overzicht",
    overview_sub: "{count} leads, gesorteerd op tijd online (oudste eerst).",
    new: "Nieuw",
    searching: "Zoeken",
    active: "Actief",
    shortlist: "Shortlist",
    signed: "Getekend",
    lost: "Verloren",
    new_lead: "Nieuwe lead",
    online_since: "Online sinds",
    not_called: "Nog niet gebeld",
    call: "Bellen",
    no_leads_title: "Nog geen leads in deze fase",
    no_leads_body: "Zodra uw Flowzy-scraper nieuwe panden binnenstuurt, verschijnen ze hier.",
    time_label: "{months} / {total} mnd",
    calls_count: "{n}×",
    scope_all: "Alle bureau-leads",
    scope_mine: "Mijn leads",
    scope_free: "Vrije leads",
    claimed_by: "Geclaimd door {name}",
    claimed_by_you: "Door u geclaimd",
    free: "Vrij",
    recent_colleague: "Recent contact collega",
    prev: "Vorige",
    next: "Volgende",
    counter: "{i} van {n}",
    recent_activity: "Recente activiteit",
    no_activity_yet: "Nog geen activiteit",
    view_all_activity: "Volledige historiek",
    platforms: {
      title: "Platform Links",
      edit: "Bewerken",
      active: "Actief",
      inactive: "Niet ingesteld",
      empty: "Nog geen links toegevoegd.",
      save: "Opslaan",
      cancel: "Annuleren",
      hint_makelaar: "Beschikbare platformen voor makelaar-leads: Zimmo, Immoweb, Immoscoop, Luxevastgoed, 2dehands, en de eigen site van de makelaar.",
      hint_particulier: "Beschikbare platformen voor particuliere leads: Zimmo, Immoweb, Immoscoop, Luxevastgoed, 2dehands.",
      placeholder: "https://…",
      labels: {
        zimmo: "Zimmo",
        immoweb: "Immoweb",
        immoscoop: "Immoscoop",
        luxevastgoed: "Luxevastgoed",
        tweedehands: "2dehands",
        site_makelaar: "Site makelaar",
      },
    },
    detail: {
      overview: "Overzicht",
      contacts: "Contacten",
      activity: "Activiteit",
      tasks: "Taken",
      urls: "URLs",
      quick_actions: "Snelle acties",
      call: "Bellen",
      mail: "Mailen",
      change_status: "Status wijzigen",
      toggle_shortlist: "Shortlist",
      price: "Prijs",
      old_price: "Oude prijs",
      surface: "Bewoonbare opp.",
      bedrooms: "Slaapkamers",
      year: "Bouwjaar",
      epc: "EPC",
      category: "Type",
      source: "Bron",
      date_posted: "Online sinds",
      assignment: "Toewijzing",
      unassigned: "Vrij — niet geclaimd",
      claim: "Claim deze lead",
      release: "Vrijgeven",
      transfer: "Toewijzen aan…",
      transfer_select: "Kies een collega",
      recent_contact_title: "Collega had recent contact",
      recent_contact_body: "{name} heeft {when} een gesprek gelogd — uitkomst: {outcome}.",
      recent_contact_note: "Notitie: \"{note}\"",
    },
    form: {
      title: "Nieuwe lead toevoegen",
      source: "Bron",
      makelaar: "Makelaar",
      particulier: "Particulier",
      address: "Adres",
      postal_code: "Postcode",
      city: "Gemeente",
      category: "Type pand",
      huis: "Huis",
      appartement: "Appartement",
      price: "Prijs (€)",
      old_price: "Vorige prijs (€)",
      bedrooms: "Slaapkamers",
      contact_name: "Naam contact",
      contact_phone: "Telefoon",
      create: "Lead aanmaken",
    },
  },
  call: {
    title: "Quick call",
    what_outcome: "Wat was de uitkomst?",
    no_answer: "Neemt niet op",
    voicemail: "Voicemail",
    answered: "Opgenomen",
    note_optional: "Korte notitie (optioneel)",
    save_shortcut: "1 2 3 kies · Enter opslaan · Esc annuleren",
    logged: "Call gelogd",
    logged_sub: "Activiteit opgeslagen op de lead.",
    lock_warning: "{name} is op dit moment in gesprek met deze lead.",
    lock_warning_sub: "U kan doorgaan, maar overweeg 5 min. te wachten om dubbele calls te vermijden.",
    proceed_anyway: "Toch bellen",
  },
  contacts: {
    title: "Contactenboek",
    sub: "{count} contacten gelinkt aan uw leads.",
    role_owner: "Eigenaar",
    role_agent: "Makelaar",
    linked_properties: "Gelinkte panden",
    empty_title: "Nog geen contacten",
    empty_body: "Contacten verschijnen hier zodra leads binnenkomen via Flowzy.",
  },
  tasks: {
    title: "Taken",
    sub: "Uw to-do voor vandaag en de komende dagen.",
    empty_title: "Geen openstaande taken",
    empty_body: "Nieuwe opvolgtaken verschijnen hier automatisch na gesprekken.",
    complete: "Afvinken",
    completed: "Voltooid",
    due: "Deadline",
  },
  reports: {
    title: "Rapporten",
    sub: "Inzichten in actieve makelaars en gebruikersactiviteit.",
    placeholder: "P1 — momenteel niet actief in de MVP.",
    tab_agents: "Makelaars online",
    tab_users: "Activiteit gebruikers",
    agents_sub: "Hoeveel panden elke makelaar momenteel online heeft staan (live_status = actief).",
    users_sub: "Aantal acties per gebruiker — calls, brieven, statuswijzigingen, notities …",
    period_label: "Periode",
    period_7: "Laatste 7 dagen",
    period_30: "Laatste 30 dagen",
    period_90: "Laatste 90 dagen",
    period_365: "Laatste 365 dagen",
    total_online: "Totaal online panden",
    col_agent: "Makelaar",
    col_company: "Kantoor",
    col_phone: "Telefoon",
    col_count: "Online",
    col_regions: "Regio's",
    col_user: "Gebruiker",
    col_role: "Rol",
    col_last_login: "Laatst online",
    col_total: "Totaal",
    unknown_agent: "Onbekende makelaar",
    no_data: "Geen gegevens beschikbaar.",
    admin_only: "Alleen toegankelijk voor admins.",
  },
  settings: {
    title: "Instellingen",
    sub: "Persoonlijke voorkeuren, postcode-toewijzing en webhook-credentials.",
    profile: "Profiel",
    postcodes_section: "Postcode-toewijzing",
    postcodes_section_sub: "Wijs postcodes toe aan gebruikers. Nieuwe leads worden automatisch geclaimd door de gebruiker met die postcode. Werken meerdere gebruikers op dezelfde postcode? Dan blijft de lead vrij tot iemand 'Claim' klikt.",
    postcodes_label: "Postcodes",
    postcodes_placeholder: "2830, 2845, 2870…",
    postcodes_save: "Opslaan",
    postcodes_saved: "Opgeslagen",
    postcodes_overlap_warning: "{count} postcode(s) toegewezen aan meerdere gebruikers — leads daar blijven vrij voor manuele claim.",
    no_postcodes: "Nog geen postcodes",
    webhook: "Webhook — Flowzy ingestion",
    webhook_sub: "Configureer uw Flowzy-scraper om leads naar dit endpoint te sturen.",
    endpoint: "Endpoint URL",
    endpoint_hint: "Standaard is je preview-URL. Na deploy: pas dit aan naar je productie-domein. De JS-code in de tabs onderaan gebruikt automatisch de hier ingestelde URL.",
    endpoint_save: "URL opslaan",
    endpoint_saved: "Opgeslagen",
    endpoint_reset: "Standaard herstellen",
    endpoint_invalid: "Voer een geldige URL in (https://…)",
    method: "Methode",
    api_key: "API key (Authorization: Bearer …)",
    idempotency: "Idempotency header",
    idempotency_hint: "Bv. {'{external_id}_{date_posted}_{price}'} — prijswijzigingen worden zo als nieuw event behandeld.",
    label: "Label",
    last_used: "Laatst gebruikt",
    never: "Nooit",
    show: "Toon",
    hide: "Verberg",
    rotate_key: "Nieuwe key genereren",
    rotate_confirm: "Oude key blijft 24u geldig (grace period). Doorgaan?",
    revoke: "Intrekken",
    revoke_confirm: "Deze API key wordt onmiddellijk ingetrokken. Doorgaan?",
    grace: "Grace (verloopt {when})",
    status_active: "Actief",
    status_grace: "Grace",
    used_24h: "24u",
    used_7d: "7d",
    used_30d: "30d",
    js_templates: "Flowzy JS-code",
    js_templates_sub: "Plak deze code in Flowzy onder de juiste overzicht-pagina. API key wordt automatisch ingevuld. U kan de code aanpassen en opslaan per tenant.",
    tab_makelaar: "Makelaars overzicht",
    tab_particulier: "Particulieren overzicht",
    tab_makelaar_website: "Makelaar website",
    copy_code: "Kopiëren",
    copied: "Gekopieerd",
    paste_hint_makelaar: "Plak deze code in Flowzy onder uw \"Makelaars overzicht\"-pagina.",
    paste_hint_particulier: "Plak deze code in Flowzy onder uw \"Particulieren overzicht\"-pagina.",
    paste_hint_makelaar_website: "Plak deze code in uw scraper voor eigen makelaar-website(s). Ondersteunt `listing.website_domain` of `listing.source` voor unieke external_id.",
    save_template: "Opslaan",
    saved: "Opgeslagen",
    reset_default: "Terug naar standaard",
    reset_confirm: "Uw aanpassingen gaan verloren. Doorgaan?",
    customized_chip: "Aangepast",
    unsaved_chip: "Niet opgeslagen wijzigingen",
    placeholders_hint: "Placeholders {'{{WEBHOOK_URL}}'} / {'{{API_KEY}}'} / {'{{DATE}}'} / {'{{TENANT_NAME}}'} worden bij weergave automatisch vervangen door de live waarden. Bewaar ze dus in je custom versie.",
  },
  roles: {
    super_admin: "Super admin",
    tenant_admin: "Tenant admin",
    sales_agent: "Sales agent",
  },
  users: {
    title: "Gebruikersbeheer",
    sub: "Beheer collega's: gebruikers aanmaken, postcodes toewijzen, wachtwoorden resetten en accounts verwijderen.",
    new: "Nieuwe gebruiker",
    name: "Naam",
    email: "E-mailadres",
    role: "Rol",
    postcodes: "Postcodes",
    password: "Wachtwoord",
    new_password: "Nieuw wachtwoord",
    actions: "Acties",
    edit_postcodes: "Postcodes wijzigen",
    reset_password: "Wachtwoord resetten",
    delete: "Verwijderen",
    delete_confirm: "Weet je zeker dat je {name} wil verwijderen? Geclaimde leads worden vrijgegeven.",
    create: "Aanmaken",
    cancel: "Annuleren",
    save: "Opslaan",
    saved: "Opgeslagen",
    no_postcodes: "Geen postcodes",
    placeholder_postcodes: "2830, 2845, 2870…",
    empty_title: "Nog geen extra gebruikers",
    empty_body: "Voeg collega's toe zodat ze zelf kunnen aanmelden en met hun eigen postcodes werken.",
  },
  particulieren: {
    title: "Particulieren",
    sub: "{count} particuliere leads in jouw postcodes, gegroepeerd zoals jij dat wilt.",
    all_tab: "Alle",
    new_group: "Nieuwe groep",
    edit_group: "Groep bewerken",
    group_name: "Groepnaam",
    group_postcodes: "Postcodes in deze groep",
    group_postcodes_hint: "Komma-gescheiden, bv. 2830, 2845",
    save_group: "Groep opslaan",
    delete_group: "Groep verwijderen",
    delete_group_confirm: "Groep \"{name}\" verwijderen?",
    empty_group: "Geen leads in deze groep.",
    placeholder_name: "Bv. Antwerpen Noord",
  },
  parkeren: {
    title: "Parkeren",
    sub: "Makelaar-leads die nog niet zijn afgerond, met focus op leads ouder dan 90 dagen.",
    age_days: "{n}d online",
    age_ready: "≥90d — klaar voor prospectie",
    filter_label: "Filter",
    filter_all: "Alle leads",
    filter_ready: "Klaar voor prospectie (≥90d)",
    filter_pending: "In afwachting (<90d)",
    filter_price_drop: "Met prijsdaling",
    filter_offline: "Mogelijk offline",
    empty_title: "Geen leads in dit filter",
    empty_body: "Pas het filter aan of wacht tot nieuwe Makelaar-leads via Flowzy binnenkomen.",
  },
};

/** Minimal translation helper with `{param}` interpolation. */
export function t(keyPath, params = {}) {
  const parts = keyPath.split(".");
  let val = nl;
  for (const p of parts) {
    val = val?.[p];
    if (val === undefined) return keyPath;
  }
  if (typeof val !== "string") return keyPath;
  return val.replace(/\{(\w+)\}/g, (_, k) => (params[k] !== undefined ? params[k] : `{${k}}`));
}

export default nl;
